import { EFontSize } from '../../../interface/fontSize';

type TObjectType = {
    key: EFontSize;
    value: string;
    isDefault?: boolean;
 }

 const fontSizeSwitchList:TObjectType[] = [
     {
         key: EFontSize.SMALL,
         value: '小字号 (默认)',
         isDefault: true
     },
     {
         key: EFontSize.MIDDLE,
         value: '中字号'
     },
     {
         key: EFontSize.LARGE,
         value: '大字号'
     }
 ];
 
 export {
     fontSizeSwitchList
 }